import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'houses',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'm12.681 4.24.834-.715a1.45 1.45 0 011.88 0l5.09 4.364A1.45 1.45 0 0121 9v6.546a1.45 1.45 0 01-1 1.381',
        key: '1qphub',
      },
    ],
    [
      'path',
      {
        d: 'M15.485 11.889A1.45 1.45 0 0116 13v6.546A1.454 1.454 0 0114.546 21H4.364a1.454 1.454 0 01-1.454-1.454V13a1.45 1.45 0 01.515-1.111l5.09-4.364a1.45 1.45 0 011.88 0z',
        key: '11pwvt',
      },
    ],
    ['path', { d: 'M7.41 20.546v-4a1 1 0 011-1h2a1 1 0 011 1v4', key: 'grn8bu' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Houses
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIuNjgxIDQuMjQuODM0LS43MTVhMS40NSAxLjQ1IDAgMDExLjg4IDBsNS4wOSA0LjM2NEExLjQ1IDEuNDUgMCAwMTIxIDl2Ni41NDZhMS40NSAxLjQ1IDAgMDEtMSAxLjM4MSIgLz4KICA8cGF0aCBkPSJNMTUuNDg1IDExLjg4OUExLjQ1IDEuNDUgMCAwMTE2IDEzdjYuNTQ2QTEuNDU0IDEuNDU0IDAgMDExNC41NDYgMjFINC4zNjRhMS40NTQgMS40NTQgMCAwMS0xLjQ1NC0xLjQ1NFYxM2ExLjQ1IDEuNDUgMCAwMS41MTUtMS4xMTFsNS4wOS00LjM2NGExLjQ1IDEuNDUgMCAwMTEuODggMHoiIC8+CiAgPHBhdGggZD0iTTcuNDEgMjAuNTQ2di00YTEgMSAwIDAxMS0xaDJhMSAxIDAgMDExIDF2NCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/houses
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Houses = createLucideIcon(__iconData);

export default Houses;
